export default __webpack_public_path__ + "static/media/LogoMenu.de60684e.svg";